'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dragAndDrop = require('../enums/drag-and-drop.js');

/**
 * Get if `DragAndDropFormats` is a string data type.
 * `string` data types do not need `JSON.stringify` or `JSON.parse` called.
 *
 * @param format DragAndDropFormats | string
 * @returns boolean
 */ const getIsStringDragAndDropFormat = (format)=>{
    return Object.values(dragAndDrop.DragAndDropFormats).includes(format);
};

exports.getIsStringDragAndDropFormat = getIsStringDragAndDropFormat;
//# sourceMappingURL=drag-and-drop.js.map
